import { render, staticRenderFns } from "./MetaSendCapiEvent.vue?vue&type=template&id=1bc5b5bf"
import script from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
export * from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
import style0 from "./MetaSendCapiEvent.vue?vue&type=style&index=0&id=1bc5b5bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports